import type { Store } from '@reduxjs/toolkit';

import type { RootState } from '~/rootState';

import { persistDynamicDataExtractions } from '~/features/dynamic-data-extraction/utils/dynamicDataExtractionStorage';

export const subscribeDynamicDataExtractionPersistence = (store: Store) => {
  let previousItems = store.getState().dynamicDataExtraction.items;

  return store.subscribe(() => {
    const nextItems = (store.getState() as RootState).dynamicDataExtraction
      .items;

    if (nextItems === previousItems) {
      return;
    }

    previousItems = nextItems;
    persistDynamicDataExtractions(nextItems);
  });
};
